import { proxy } from 'valtio'

interface ScreenMaskDimensions {
  x: number
  y: number
  width: number
  height: number
  clearAreaX: number
  clearAreaY: number
  clearAreaWidth: number
  clearAreaHeight: number
}

interface ScreenMaskType {
  opened: boolean
  dimensions: ScreenMaskDimensions
}

const DEFAULT_SCREEN_MASK_DIMENSIONS: ScreenMaskDimensions = {
  x: 12,
  y: 12,
  width: 300,
  height: 100,
  clearAreaX: 0,
  clearAreaY: 0,
  clearAreaWidth: 200,
  clearAreaHeight: 50,
}

const initialState: ScreenMaskType = {
  opened: false,
  dimensions: DEFAULT_SCREEN_MASK_DIMENSIONS,
}

export const ScreenMaskState = proxy<ScreenMaskType>(initialState)

export const toggleScreenMaskOpened = (status: boolean) => {
  ScreenMaskState.opened = status
}

export const updateScreenMaskDimensions = (dimensions: Partial<ScreenMaskDimensions>) => {
  ScreenMaskState.dimensions = {
    ...ScreenMaskState.dimensions,
    ...dimensions,
  }
}

export const resetScreenMaskState = () => {
  ScreenMaskState.opened = initialState.opened
  ScreenMaskState.dimensions = { ...DEFAULT_SCREEN_MASK_DIMENSIONS }
}
